import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import translate from "./../../services/translation.json";
import "./useCases.scss";

function highlightText(text) {
  return text.split(" ").map((word, i) => {
    if (
      word.toLowerCase().includes("reduced") ||
      word.toLowerCase().includes("improved") ||
      word.toLowerCase().includes("automated") ||
      word.toLowerCase().includes("real-time") ||
      word.toLowerCase().includes("centralized") ||
      word.toLowerCase().includes("reduzierte") ||
      word.toLowerCase().includes("verbesserte") ||
      word.toLowerCase().includes("automatisierte") ||
      word.toLowerCase().includes("echtzeit") ||
      word.toLowerCase().includes("zentrale")
    ) {
      return (
        <span key={i} className="highlight">
          {word}{" "}
        </span>
      );
    }
    return word + " ";
  });
}

export default function UseCases({ lang = "en" }) {
  const portfolio = translate[lang].portfolio;
  const projects = portfolio.projects;
  const [active, setActive] = useState(projects[0]);

  // Update active project when language changes
  useEffect(() => {
    const currentProjects = translate[lang].portfolio.projects;
    const currentIndex = projects.findIndex((p) => p.id === active.id);
    setActive(currentProjects[currentIndex] || currentProjects[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  return (
    <div className="success-stories">
      <div className="container">
        <h2 className="section-title">{portfolio.section_title}</h2>

        {/* CARDS */}
        <div className="cards">
          {projects.map((item) => (
            <div
              key={item.id}
              className={`card ${active.id === item.id ? "active" : ""}`}
              onClick={() => setActive(item)}
            >
              <h3>{item.title}</h3>
              <p>
                {portfolio.client_label}: {item.client}
              </p>
              <p>
                {portfolio.niche_label}: {item.niche}
              </p>
            </div>
          ))}
        </div>

        {/* ACTIVE CASE */}
        <AnimatePresence mode="wait">
          <motion.div
            key={active.id}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -40 }}
            transition={{ duration: 0.5 }}
            className="case"
          >
            <h2 className="title">{active.title}</h2>

            <p className="meta">
              {portfolio.client_label}: {active.client} <br />
              {portfolio.niche_label}: {active.niche}
            </p>

            <h3 className="subtitle">{portfolio.challenge_label}</h3>
            <p className="text">{highlightText(active.challenge)}</p>

            {/* Timeline */}
            <div className="timeline">
              <motion.div
                className="line"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 0.6 }}
              />

              <div className="steps">
                {active.steps.map((step, i) => (
                  <motion.div
                    key={i}
                    className="step"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * 0.15 }}
                  >
                    <div className="dot" />
                    <div className="vertical" />
                    <span>{step}</span>
                  </motion.div>
                ))}
              </div>
            </div>

            <h3 className="subtitle">{portfolio.results_label}</h3>
            <div className="results">{highlightText(active.results)}</div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}